import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';

class OfficeListItem extends Component {
  render() {
    let { data, focused, id } = this.props;

    return (
      <div
        className={`side-menu-list-obj office ${focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        id={id}
        onClick={this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: data.color }}>
          <div className="obj-title" onClick={this.props.onTitleClick}>
            {data.name}
          </div>
          <div className="obj-data">{data.addressline1}</div>
          <div className="obj-data">
            {data.city}, {data.statecode}, {data.zip5}
          </div>

          {/* CONDITIONAL AGGREGATE DATA INJECTION */}
          {![null, undefined].includes(data.num_response) && (
            <div className={'obj-data'}>
              Responses: <span className="primary-text">{data.num_response}</span>
            </div>
          )}
          {![null, undefined].includes(data.num_checkins) && (
            <div className={'obj-data'}>
              Check Ins: <span className="primary-text">{data.num_checkins}</span>
            </div>
          )}
          {![null, undefined].includes(data.num_sites_checked_into) && (
            <div className={'obj-data'}>
              Sites Checked Into:{' '}
              <span className="primary-text">{data.num_sites_checked_into}</span>
            </div>
          )}
          {![null, undefined].includes(data.canvasser_count) && (
            <div className={'obj-data'}>
              Canvassers: <span className="primary-text">{data.canvasser_count}</span>
            </div>
          )}
          {![null, undefined].includes(data.door_targets_canvassed) && (
            <div className={'obj-data'}>
              Targets Canvassed: <span className="primary-text">{data.door_targets_canvassed}</span>
            </div>
          )}
          {![null, undefined].includes(data.households_canvassed) && (
            <div className={'obj-data'}>
              Household Canvassed: <span className="primary-text">{data.households_canvassed}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default OfficeListItem;
